"use strict";

exports.__esModule = true;
exports["default"] = void 0;

var _react = _interopRequireWildcard(require("react"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _propTypes = require("prop-types");

var _ramda = require("ramda");

var _animations = require("@qc-modules/animations");

var _utils = require("../../utils");

var _primitives = _interopRequireDefault(require("../../primitives"));

var _categoryItem = _interopRequireDefault(require("./category-item"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

var CategoriesWrapper = (0, _styledComponents["default"])(_primitives["default"].Box).withConfig({
  displayName: "filters-categories__CategoriesWrapper",
  componentId: "sc-1i28olf-0"
})(["& > div{-webkit-overflow-scrolling:touch;}"]);
var CategoriesContainer = (0, _styledComponents["default"])(_primitives["default"].Flex).withConfig({
  displayName: "filters-categories__CategoriesContainer",
  componentId: "sc-1i28olf-1"
})(["min-width:", "px;box-sizing:content-box;"], function (_ref) {
  var items = _ref.items;
  return items * 240;
});
var propTypes = {
  /** Current active category determined by value */
  active: _propTypes.string,
  animating: _propTypes.bool,

  /** List of categories * */
  categories: (0, _propTypes.arrayOf)((0, _propTypes.shape)({
    id: _propTypes.string,
    title: _propTypes.string,
    value: _propTypes.string
  })),
  categoriesTitle: _propTypes.node,

  /** click handler for item  */
  categoryClickHandler: _propTypes.func,

  /** click handler Internal  */
  itemClickHandler: _propTypes.func,

  /** setting for number of item gutters * */
  itemGutter: (0, _propTypes.oneOfType)([_propTypes.array, _propTypes.string, _propTypes.number]),

  /** setting for number of item width * */
  itemWidth: (0, _propTypes.oneOfType)([_propTypes.array, _propTypes.string, _propTypes.number]),
  scrollValue: _propTypes.number,
  updateAnimation: _propTypes.func
};
var titleFont = {
  color: "text-title",
  fontSize: 6,
  fontWeight: 1,
  lineHeight: 2,
  ml: [0, 2]
};

var FiltersCategories = function FiltersCategories(_ref2) {
  var active = _ref2.active,
      categories = _ref2.categories,
      categoryClickHandler = _ref2.categoryClickHandler,
      _ref2$itemWidth = _ref2.itemWidth,
      itemWidth = _ref2$itemWidth === void 0 ? 1 / 3 : _ref2$itemWidth,
      _ref2$itemGutter = _ref2.itemGutter,
      itemGutter = _ref2$itemGutter === void 0 ? 12 : _ref2$itemGutter,
      categoriesTitle = _ref2.categoriesTitle;

  var _useState = (0, _react.useState)({
    animating: false,
    scrollValue: 0
  }),
      _useState$ = _useState[0],
      animating = _useState$.animating,
      scrollValue = _useState$.scrollValue,
      setScroll = _useState[1];

  var itemClickHandler = (0, _react.useCallback)(function (props, index) {
    (0, _utils.callIfFunc)(categoryClickHandler, props);
    setScroll({
      animating: true,
      scrollValue: index / (categories.length - 1)
    });
  }, [categories, categoryClickHandler]);
  var updateAnimation = (0, _react.useCallback)(function (status) {
    return setScroll({
      animating: status,
      scrollValue: scrollValue
    });
  }, [scrollValue]);
  return /*#__PURE__*/_react["default"].createElement(CategoriesWrapper, {
    pt: 3
  }, /*#__PURE__*/_react["default"].createElement(_primitives["default"].Box, {
    px: [3, 3, 0]
  }, /*#__PURE__*/_react["default"].createElement(_primitives["default"].Text, titleFont, categoriesTitle)), /*#__PURE__*/_react["default"].createElement(_animations.ScrollTo, {
    allowScrollX: true,
    allowScrollY: false,
    animating: animating,
    scrollByPercentage: true,
    scrollX: scrollValue,
    updateAnimation: updateAnimation
  }, /*#__PURE__*/_react["default"].createElement(CategoriesContainer, {
    items: (0, _ramda.isEmpty)(categories) ? 0 : categories.length,
    px: [3, 3, 0],
    py: 3,
    width: 1
  }, /*#__PURE__*/_react["default"].createElement(_primitives["default"].Box, {
    mx: [(0, _ramda.negate)(itemGutter) + "px", (0, _ramda.negate)(itemGutter) + "px", 0],
    width: ["auto", "auto", 1]
  }, /*#__PURE__*/_react["default"].createElement(_primitives["default"].Box, {
    width: 1
  }, (0, _utils.mapIndexed)(function (_ref3, index) {
    var id = _ref3.id,
        label = _ref3.label,
        value = _ref3.value;
    return /*#__PURE__*/_react["default"].createElement(_categoryItem["default"], {
      key: id,
      categoryClick: function categoryClick(event) {
        return itemClickHandler({
          event: event,
          id: id,
          label: label,
          value: value
        }, index);
      },
      isActive: active === value,
      itemGutter: itemGutter,
      itemWidth: itemWidth,
      label: label,
      value: value
    }, label);
  }, categories))))));
};

FiltersCategories.propTypes = propTypes;
FiltersCategories.displayName = "Modules.FiltersCategories";
var _default = FiltersCategories;
exports["default"] = _default;